import { pt, es, enUS } from 'date-fns/locale';
import { icon, findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons/faXTwitter';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTiktok } from '@fortawesome/free-brands-svg-icons/faTiktok';
import { faRss } from '@fortawesome/pro-regular-svg-icons';

export const networks = {
  INSTAGRAM: 'instagram',
  INSTAGRAM_GRAPH: 'instagramGraph',
  YOUTUBE: 'youtube',
  TWITTER: 'twitter',
  CUSTOM: 'custom',
  OPEN_GRAPH: 'openGraph',
  TIK_TOK: 'tikTok',
  RSS: 'rss_feeds',
};

export const AnalyticsEvents = {
  EMBED_PAGE_VIEW: 'EMBED_PAGE_VIEW',
  EMBED_VIEW: 'EMBED_VIEW',
  EMBED_UNVIEW: 'EMBED_UNVIEW',
  EMBED_VIEW_POLL: 'EMBED_VIEW_POLL',
  CTA_CLICK: 'CTA_CLICK',
  OPEN_POST: 'OPEN_POST',
  FOCUS_POST: 'FOCUS_POST',
  SHARE_POST: 'SHARE_POST',
  SEE_MORE: 'SEE_MORE',
};

export const AnalyticsScores = {
  SEE_MORE: 70,
  CTA_CLICK: 100,
  SHARE_POST: 100,
  OPEN_POST: 75,
  SECOND_OPEN_POST: 85,
  FOCUS_POST: 40,
  SECOND_FOCUS_POST: 50,
};

export const AnalyticsPollTime = 10000;
export const AnalyticsMaxPollTime = 300000;

export const EmbedTypes = {
  GRID: 'grid',
  CAROUSEL: 'carousel',
  MASONRY: 'masonry',
};

export const mediaFilterTypes = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  BOTH: 'BOTH',
};

export const ShareNetworks = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
  LINKEDIN: 'linkedin',
  EMAIL: 'email',
  LINK: 'link',
};

export const LOCALES = ['pt', 'es', 'en'];

export const DATE_FNS_LOCALES = {
  pt,
  es,
  en: enUS,
  'en-US': enUS,
};

const faGigg = findIconDefinition({ prefix: 'fab', iconName: 'gigg' });

export const NETWORK_ICONS = {
  [networks.TWITTER]: faXTwitter,
  [networks.INSTAGRAM]: icon(faInstagram),
  [networks.YOUTUBE]: faYoutube,
  [networks.CUSTOM]: icon(faGigg),
  [networks.TIK_TOK]: faTiktok,
  [networks.RSS]: faRss,
};
